// libraries
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

// styles
import styles from "./styles.module.scss";

// components
import { Heading } from "src/components";

// utils
import mockup from "src/utils/data";
import { getNextCategories } from "src/utils/helpers";

const ByCategory = ({ handleClick, currCategory }) => {
  // states
  // const [activeTag, setActiveTag] = useState(0);
  const [list, setList] = useState([]);
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    if (currCategory) {
      setList(getNextCategories(currCategory, mockup.by_category));
      setIsShow(false);
    }
  }, [currCategory]);

  const showEvents = (_catgData) => {
    handleClick(_catgData);
  };

  const showAll = () => {
    let filter = [...list];
    let arr = mockup.by_category;

    for (let i = 0; i < arr.length; i++) {
      let check = false;
      for (let j = 0; j < list.length; j++) {
        if (arr[i].data.Categoryid === list[j].data.Categoryid) {
          check = true;
        }
      }
      if (!check) filter.push(arr[i]);
    }

    setIsShow(true);
    setList(filter);
  };

  return (
    <div className={styles.by_category}>
      <Heading
        heading="Events by category"
        to={!isShow}
        handleClick={showAll}
      />
      {/* <Tags tags={tags} activeTag={activeTag} setActiveTag={setActiveTag} /> */}
      <div className={styles.inner}>
        <motion.div
          className={styles.items}
          transition={{
            staggerChildren: 0.5,
          }}
        >
          {list.map((item, index) => (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className={styles.item}
              key={index}
              onClick={() => showEvents(item.data)}
            >
              <img src={item.image} alt={item.data.CategoryName} />
              <span>{item.data.CategoryName}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default ByCategory;
